import { render, staticRenderFns } from "./SupportMaterials.vue?vue&type=template&id=1d9cb940&scoped=true&"
import script from "./SupportMaterials.vue?vue&type=script&lang=js&"
export * from "./SupportMaterials.vue?vue&type=script&lang=js&"
import style0 from "./SupportMaterials.vue?vue&type=style&index=0&id=1d9cb940&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9cb940",
  null
  
)

component.options.__file = "SupportMaterials.vue"
export default component.exports